/** How an account was created. Mirrors `SignUpMethod` in the server's signUpMethod.service. */
export type SignUpMethod = 'magicLink' | 'google' | 'github';

/**
 * The server refuses a Google sign in for an account created with a magic link, answering
 * `SIGN_IN_UP_NOT_ALLOWED` with this prefix and the account's email as the reason.
 */
const ACCOUNT_USES_MAGIC_LINK = 'ACCOUNT_USES_MAGIC_LINK:';

/** Returns the email to send the magic link to, or null when the refusal is for another reason. */
export function getMagicLinkRedirectEmail(reason: string): string | null {
  if (!reason.startsWith(ACCOUNT_USES_MAGIC_LINK)) {
    return null;
  }

  const email = reason.slice(ACCOUNT_USES_MAGIC_LINK.length);
  return email || null;
}

/** Router state Login reads to auto-send a magic link after a refused Google sign in. */
export type MagicLinkRedirectState = { magicLinkRedirectEmail: string };
